export enum fraud_and_risk_level {
  low,
  medium,
  high,
}
